module.exports = __webpack_public_path__ + "img/save.98bb55f8.svg";